import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { ComponentListPageContext, ComponentListPageInitialState } from ".";

export const ComponentListPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(ComponentListPageInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <ComponentListPageContext.Provider value={context}>
      {children}
    </ComponentListPageContext.Provider>
  );
};
